<template>
  <div id="assets_liabilities_details">
    <group-card title="Assets & Liabilities" icon="house" :tooltipText="tooltipText">
      <template v-slot:actions v-if="index > 0">
        <md-checkbox
          v-model="is_same_as_applicant"
          @change="copyFromApplicant1()"
          >Same as applicant 1</md-checkbox
        >
      </template>
      <draggable
        v-model="applicant.assets"
        handle=".handle"
        group="assets"
        ghostClass="draggable-ghost-class"
        class="md-layout-item"
      >
        <!-- Asset array inputs -->
        <list-item-card
          v-for="(asset, index) in applicant.assets"
          :key="id(asset)"
          class="asset-card"
        >
          <div class="md-layout">
            <div class="md-layout-item">
              <edit-applicant-asset
                :value="asset"
                @set-as-trade-in="setAsTradeIn(asset)"
                :index="index"
                @change-asset="setNewAsset"
                :prefixLabel="prefixLabel + ' ' + (index + 1)"
              />
            </div>
            <div class="md-layout-item">
              <edit-applicant-liability
                :value="asset"
                :prefixLabel="prefixLabel + ' ' + (index + 1)"
              />
            </div>
            <div class="md-layout-item md-small-size-20 md-size-10 icons">
              <md-button class="md-just-icon md-simple"
              ><md-icon class="handle">drag_indicator</md-icon>
              <md-tooltip md-direction="top">Drag to change the order</md-tooltip></md-button>
              <md-button
              class="md-just-icon md-danger md-simple"
              @click="removeAssets(applicant.assets, asset)"
              ><md-icon>close</md-icon>
              <md-tooltip md-direction="top">Delete</md-tooltip></md-button>
            </div>
          </div>
          <div class="md-layout" v-if="asset.type === 'Investment Property'">
            <div class="md-layout-item">
              <edit-applicant-investment-property-address
                v-model="asset.address"
                :applicant-id="applicant.id"
                :prefixLabel="prefixLabel + ' ' + (index + 1)"
              />
            </div>
          </div>
        </list-item-card>
      </draggable>
      <!-- Add -->
      <div class="md-layout-item">
        <md-button class="md-primary md-sm" @click="addListItem">Add</md-button>
      </div>
    </group-card>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import filters from "@/components/utils/filters";
import utils from "@/components/utils/utils";
import ValidatedInputs from "@/components/ValidatedInput";
import GroupCard from "@/components/Cards/GroupCard";
import GroupCardRow from "@/components/Cards/GroupCardRow";
import ListItemCard from "@/components/Cards/ListItemCard.vue";
import draggable from "vuedraggable";
import EditApplicantAsset from "./EditApplicantAsset.vue";
import EditApplicantLiability from "./EditApplicantLiability.vue";
import EditApplicantInvestmentPropertyAddress from "./EditApplicantInvestmentPropertyAddress.vue";
import transitions from "@/components/utils/transitions";
import { newAsset } from "@/schema.js";
import ConfirmDialog from "../Dialogs/ConfirmDialog";

export default {
  components: {
    ...ValidatedInputs,
    GroupCard,
    GroupCardRow,
    ListItemCard,
    draggable,
    EditApplicantAsset,
    EditApplicantLiability,
    EditApplicantInvestmentPropertyAddress,
  },
  data() {
    return {
      transitions,
      is_same_as_applicant: false,
      tooltipText: '<li>An Asset is something that is owned outright by the client - Liability is something in the ' +
                    'clients name that currently has money owed.</li><li>If any liabilities collect all information required</li>',

    };
  },
  props: {
    value: {
      type: Object,
      required: true,
    },
    application: {
      type: Object,
      required: true,
    },
    prefixLabel: {
      type: String,
      default: "",
    },
    index: {
      type: [Number, String],
      default: 0,
    },
  },
  computed: {
    // standard list of options from store
    ...mapGetters({
    }),

    // internal reference to the v-model on this component, handles incomeing and outgoing changes
    applicant: {
      get() {
        return this.value;
      },
      set(applicant) {
        this.$emit("input", applicant);
      },
    },
  },
  methods: {
    // make all filters available as methods
    ...filters,
    ...utils,
    addListItem() {
      this.applicant.assets.push(newAsset());
    },
    setNewAsset({asset , newAssetType , index}) {
      let newAssetObj = newAsset();
      newAssetObj.id = asset.id ?? null;
      newAssetObj.type = newAssetType;
      this.applicant.assets.splice(index,1,newAssetObj)
    },
    setAsTradeIn(trade_in_asset) {
      for (let asset of this.applicant.assets) {
        if (asset != trade_in_asset) {
          asset.has_trade_in = false;
        }
      }
    },
    async removeAssets(applicantAssets, assets) {
      if (assets.has_liability == true) {
        var message = "liabilities"
      } else {
        var message = "assets"
      }
      if (assets.type) {
        if (await this.showConfirmDialog('Remove Assets & Liabilities' ,`Are you sure to delete '${assets.type}' ${message} ?`)) {
          this.arrayRemove(applicantAssets, assets);
        }
      } else {
        this.arrayRemove(applicantAssets, assets);
      }
    },
    async showConfirmDialog(title, message) {
      return await this.$modal.show(ConfirmDialog, {
        title: title,
        message: message,
        confirmText: "Delete",
        cancelText: 'Cancel',
      });
    },
    async copyFromApplicant1() {
      if (this.is_same_as_applicant) {
        await this.$store.dispatch("copyFromApplicant1", {
          type: "assets_and_liabilities",
          applicant_index: this.index,
        });
      }
    }
  },
  filters: {
    // make all filters available as filters
    ...filters,
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/scss/theme.scss";

.draggable {
  padding: 0px;
}

.icons{
  display: flex;
  flex-direction: row;
}
.asset-card {
  padding-top: 10px;
  padding-bottom: 10px;
  margin: 15px 0px;
  }

</style>
